angular.module('ui2.0Controllers').controller('novationController', ['$scope', '$uibModal', '$rootScope', '$location', '$templateCache', '$compile', '$timeout', '$http', '$window', '$anchorScroll', 'urlFactory', '$routeParams', '$sce', '$document', '$route', '$filter', '$q', function ($scope, $modal, $rootScope, $location, $templateCache, $compile, $timeout, $http, $window, $anchorScroll, urlFactory, $routeParams, $sce, $document, $route, $filter, $q) {
    $scope.novationPopupObj = {};
    $scope.novateData = $scope.$parent.novateData;
    $scope.docTreeData=$rootScope.docTree;
    $scope.bulkNovation=$rootScope.bulkNovation;
    $scope.novationPopupObj.finalSuccess = false;
    $scope.novationPopupObj.isNovateNow = false;
    $scope.novationPopupObj.moveContract = false;
    $scope.novationPopupObj.ddFormat = SirionUtils.getDateFormat();
    $scope.supplierTable = [];
    $scope.errorObj = {};
    $scope.novatePopupFirstTab = true;
    $scope.novatePostData = {
        "parentType": $scope.novateData.destinationJson[1],
        "sendDestinationSupplierNovate": {},
        "addNewRelationsToUnderLyingContracts": true,
        "newRelations": {"values": []},
        "parentContract": {},
        "effectiveNovationDate": moment(new Date(), SirionUtils.getDateFormat()).format(SirionUtils.getActualDateFormat())
    };
    $scope.fieldLayoutData = {
        "replaceSupplier": {
            "id": 12030,
            "name": "novationReplaceSupplier",
            "label": "Replace Supplier",
            "type": "select",
            "orderSeq": 10,
            "properties": {},
            "displayMode": "editable",
            "dynamicField": false,
            "editableHtmlType": 3,
            "autoComplete": false,
            "enableListView": false,
            "bulkEditable": false,
            "multiEntitySupport": false
        },
        "newSupplier": {
            "id": 12030,
            "name": "novationNewSupplier",
            "label": "New Supplier",
            "type": "select",
            "orderSeq": 10,
            "properties": {"multiple": true},
            "displayMode": "editable",
            "dynamicField": false,
            "editableHtmlType": 3,
            "autoComplete": false,
            "enableListView": false,
            "bulkEditable": false,
            "multiEntitySupport": false
        },
        "parentContract": {
            "id": 12030,
            "name": "moveDocumentContract",
            "label": "New Supplier",
            "type": "select",
            "orderSeq": 10,
            "properties": {},
            "displayMode": "editable",
            "dynamicField": false,
            "editableHtmlType": 3,
            "autoComplete": false,
            "enableListView": false,
            "bulkEditable": false,
            "multiEntitySupport": false
        }
    };
    $scope.disableAddMoreButton = false;
    $scope.init = function () {
        if($scope.novateData.isRequestAlreadyExists){
            angular.element(".novationPopupDialog").addClass("novationSuccessDialog");
            $scope.submitErrorObj = $scope.novateData.extraInformation;
            $scope.submitErrorObj.userInitials = globalFunc.getUserInitials($scope.submitErrorObj.requestedUser);
        }else{
            SirionUtils.setUpCommonPicker.call($scope, 'effectiveNovationDate', "", true, false);
            var reqUrl = '/novation-tree/v1/' + $scope.novateData.contractEntityTypeId + '/' + $scope.novateData.sourceId;
            let supplierTableObj = {'existingSuppliers': [], "replacedSuppliers": {"values": null}, existingSuppliersOptions: $scope.novateData.sourceRelations};
            if (!$scope.novateData.isMultiSupplier) {
                supplierTableObj.existingSuppliers = $scope.novateData.sourceRelations;
            }
            $scope.supplierTable.push(supplierTableObj);

            !$scope.bulkNovation && $http.get(reqUrl).then(function (resp) {
                if (resp.data && resp.data.body && resp.data.body.data) {
                    $scope.docTreeData = resp.data.body.data;
                }
                stopLoader();
            });
        }
    }
    $scope.init();
    $scope.isNovateNow = function (event) {
        if ($scope.novationPopupObj.isNovateNow) {
            $scope.novatePostData.effectiveNovationDate = moment(new Date(), SirionUtils.getDateFormat()).format(SirionUtils.getActualDateFormat());
        }
    };
    $scope.moveContract = function (event) {
        $scope.novatePostData.parentContract = {};
        $scope.novatePostData.parentType = $scope.novateData.destinationJson[1];
        $scope.novatePostData.effectiveNovationDate = moment(new Date(), SirionUtils.getDateFormat()).format(SirionUtils.getActualDateFormat());

        if(!$scope.novationPopupObj.moveContract){
            $scope.novatePostData.sendDestinationSupplierNovate = {};
            $scope.novatePostData.addNewRelationsToUnderLyingContracts = true;
            $scope.novatePostData.newRelations = {"values": []};
            $scope.novatePostData.effectiveNovationDate = moment(new Date(), SirionUtils.getDateFormat()).format(SirionUtils.getActualDateFormat());
            if($scope.supplierTable.length>1) {
                $scope.supplierTable.forEach(function (item, index) {
                    if (item && item['replacedSuppliers'] && item['replacedSuppliers']['values']) {
                        item['replacedSuppliers']['values'] = {};
                    }
                    if (item.existingSuppliers.length) {
                        item.existingSuppliers = [];
                    }
                });
            }
            else{
                $scope.supplierTable.forEach(function (item, index) {
                    if (item && item['replacedSuppliers'] && item['replacedSuppliers']['values']) {
                        item['replacedSuppliers']['values'] = {};
                    }
                });
            }
        }
    };
    $scope.onReplaceSupplier = function () {
        var flag = true;
        $scope.novatePostData.replaceRelationPairs = [];
        $scope.supplierTable.forEach(function (item, index) {
            if (item && item['replacedSuppliers'] && !_.isEmpty(item['replacedSuppliers']['values']) && item.existingSuppliers.length) {
                $scope.errorObj['errorExistingSupplier'] = false;
                item.existingSuppliers.map(function (obj) {
                    $scope.novatePostData.replaceRelationPairs[$scope.novatePostData.replaceRelationPairs.length] = {
                        "left": obj.id,
                        "right": item.replacedSuppliers.values.id
                    };
                    if ($scope.errorObj['errorDestinationSupplier'] == true) {
                        $scope.errorObj['errorDestinationSupplier'] = false;
                    }
                    if ($scope.errorObj['errorExistingSupplier'] == true) {
                        $scope.errorObj['errorExistingSupplier'] = false;
                    }
                });
            } else if(!$scope.novatePostData.newRelations.values.length && !$scope.novatePostData.replaceRelationPairs.length ) {
                if(!item.existingSuppliers.length){
                    $scope.errorObj['errorExistingSupplier'] = true;
                    flag = false;
                }
                if(_.isEmpty(item['replacedSuppliers']['values'])) {
                    $scope.errorObj['errorDestinationSupplier'] = true;
                    flag = false;
                }
            }
        });
        return flag;
    }
    $scope.submitNovate = function () {
        var obj = {};
        if($scope.novationPopupObj.moveContract){
            let sourceIds=$scope.novateData.sourceId;
            if($scope.bulkNovation){
                sourceIds=[];
                $scope.docTreeData.forEach(item=>{
                    sourceIds.push(item.entityId)
                })
                obj.bulkNovation=true
                obj['sourceIds']=sourceIds;
            }else{
                obj['sourceId']=sourceIds;
            }
            obj['sourceParentId'] = null;
            obj['onlyContractMove'] = true
        }
        else{
            if (!$scope.onReplaceSupplier() && !$scope.novatePostData.newRelations.values.length) {
                return;
            }
            let sourceIds=$scope.novateData.sourceId;
            if($scope.bulkNovation){
                sourceIds=[];
                $scope.docTreeData.forEach(item=>{
                    sourceIds.push(item.entityId)
                })
                obj.bulkNovation = true;
                obj['sourceIds'] = sourceIds;
            } else {
                obj['sourceId'] = sourceIds;
            }
            obj['sourceParentId'] = null;
            obj['onlySupplierAddition'] = true;

            if ($scope.novatePostData.replaceRelationPairs.length) {
                obj['replaceRelationPairs'] = $scope.novatePostData.replaceRelationPairs;
                obj['onlySupplierAddition'] = false;
            }
            if ($scope.novatePostData.newRelations && $scope.novatePostData.newRelations.values && $scope.novatePostData.newRelations.values.length) {
                obj['newRelations'] = $scope.novatePostData.newRelations.values.map(obj => obj.id);
                obj['addNewRelationsToUnderLyingContracts'] = $scope.novatePostData.addNewRelationsToUnderLyingContracts;
            }
        }

        obj['effectiveNovationDate'] = $scope.novatePostData.effectiveNovationDate ? moment(new Date(), SirionUtils.getDateFormat()).format(SirionUtils.getDBDateFormat()) : moment(new Date(), SirionUtils.getDateFormat()).format(SirionUtils.getDBDateFormat());
        let destinationEntityType = $scope.novatePostData.parentType.destinationEntityType;
        obj['destinationEntityTypeId'] = destinationEntityType;
        if (destinationEntityType == 61 && $scope.novatePostData.parentContract.values && $scope.novatePostData.parentContract.values.id) {
            obj.destinationId = $scope.novatePostData.parentContract.values.id;
            if ($scope.errorObj['errorParentContract'] == true) {
                $scope.errorObj['errorParentContract'] = false;
            }
        } else if (destinationEntityType == 61) {
            $scope.errorObj['errorParentContract'] = true;
            return;
        }
        startLoader();
        var promise = requestData("POST", $scope.novateData.submitURL, obj);
        promise.success(function (data) {
            if (data.header && data.header.response && (data.header.response.status == "error" || data.header.response.status == "applicationError")) {
                if((data.body?.errorMessages) || data.header?.response?.message){
                    let arr = data.body?.errorMessages || [data.header?.RESPONSE_PROPERTIES];
                    let htmlError="<p class='beginErr'>"+`${data.body?.message || data.header?.response?.message}`+"</p>";
                    if(arr){
                        if(arr.length == 1){
                            htmlError+=(arr[0]["errorMessage"] || arr[0]);
                        }else{
                            for(var i = 0;i<arr.length;i++){
                                htmlError+="<p class='errorLine'><span class='sno'>"+(i+1)+". </span><span class='textSpan'>"+arr[i]["errorMessage"]+"</span></p>";
                            }
                        }
                    }
                    const args = {
                        popupType: 'alert',
                        str: htmlError,
                        heading: "ERROR",
                        yesCbFn: 'cancel',
                        yesName: intl_msg[24184]
                    }
                    SirionUtils.openSirionDialogs(args);
                }
            } else if (data.header && data.header.response && data.header.response.status == "success") {
                $scope.novationPopupObj.finalSuccess = true;
                angular.element(".novationPopupDialog").addClass("novationSuccessDialog");
            }
            $timeout(() => {
                stopLoader();
                $('.alertdialog').addClass('novationAlertBox');
            })
        });
        promise.error(function (err) {
        });
    };
    $scope.openCalendarPopup = function (e, which, calculatePos) {
        e.preventDefault();
        var calPromise = new Promise(function (res, rej) {
            e.stopPropagation();
            if ($scope.commonDatepicker.opened[which] == true) {
                $scope.datepicker.opened[which] = false;
            } else {
                $scope.commonDatepicker.opened[which] = true;
                $scope.$broadcast('closeMsDD');
            }
            var resObj = {'evt': e, 'calPos': calculatePos}
            res(resObj);
        });
        calPromise.then(function (resObj) {
            if (resObj.calPos || $scope.metadatasearchPage) {
                showPageService.setPositionOfDatepicker(resObj.evt.target);
            }
        });
    };
    $scope.findExistingSuppliers = function(array){
        let selectedValues =  array.map(obj=>  { return obj.existingSuppliers });
        selectedValues = _.flatten(selectedValues);
        return selectedValues;
    }
    $scope.$watch('supplierTable', function (newValue, oldValue, scope) {
        _.map(newValue,function(item) {
            let selSupToBeReplaced = $scope.findExistingSuppliers($scope.supplierTable);
           item['existingSuppliersOptions'] = $scope.novateData.sourceRelations.filter(obj => {if(item['existingSuppliers'].includes(obj) || !selSupToBeReplaced.includes(obj))return obj});
           if($scope.novateData.sourceRelations.length == selSupToBeReplaced.length){
               $scope.disableAddMoreButton = true;
           }else{
               $scope.disableAddMoreButton = false;
           }
        });
    }, true);
    $scope.addTableRow = function () {
        const supplierTableObj = {'existingSuppliers': [], "replacedSuppliers": {"values": null}, existingSuppliersOptions: []};
        let selSupToBeReplaced = $scope.findExistingSuppliers($scope.supplierTable);
        supplierTableObj['existingSuppliersOptions'] = $scope.novateData.sourceRelations.filter(obj => {if(!selSupToBeReplaced.includes(obj))return obj});
        $scope.supplierTable.push(supplierTableObj);

    }
    $scope.removeTableRow = function(index, value){
        let optionsToAdd =  value.existingSuppliers;
        $scope.supplierTable.forEach(obj=>{
            obj.existingSuppliersOptions =  _.union( obj.existingSuppliersOptions, optionsToAdd);
        });
        $scope.supplierTable.splice(index,1);
        $scope.disableAddMoreButton = false;
    };

    function buildNovationFallbackGetData(baseUrl) {
        return function(args) {
            var loaded = (args.autoCompleteDetails && args.autoCompleteDetails.loaded) || 0;
            if (args.advanceSearchUrl) {
                var sep = args.advanceSearchUrl.indexOf('?') !== -1 ? '&' : '?';
                var advanceUrl = args.advanceSearchUrl + sep + 'offset=' + (args.isLoadMore ? loaded : 0);
                if (args.query || args.searchChar) {
                    advanceUrl += '&query=' + encodeURIComponent((args.query || '') + (args.searchChar || ''));
                } else {
                    advanceUrl += '&expandAutoComplete=true';
                }
                var postData = {};
                if (window.advanceFilterPayload && !angular.equals(window.advanceFilterPayload.filterMap, {})) {
                    postData.filterMap = window.advanceFilterPayload.filterMap || {};
                }
                return $http.post(advanceUrl, postData).then(function(res) {
                    var d = res.data || {};
                    return { data: { data: d.data || [], hasNext: d.hasNext !== false } };
                });
            }
            var url = baseUrl + '&query=' + encodeURIComponent((args.query || '') + (args.searchChar || '')) + '&offset=' + (args.isLoadMore ? loaded : 0);
            if (!args.query && !args.searchChar) {
                url = baseUrl + '&expandAutoComplete=true&offset=0';
            }
            return $http.get(url).then(function(res) {
                var d = res.data || {};
                return { data: { data: d.data || [], hasNext: d.hasNext !== false } };
            });
        };
    }

    $scope.openNovationSupplierModal = function(event, mode, item) {
        if (!window.reactComponents) return;
        event.preventDefault();
        event.stopPropagation();
        var mountAt = document.getElementById('novationSirionSelectModalMount');
        if (!mountAt) return;
        // Unmount any existing modal so the new one gets fresh state (correct selectedOptions).
        // Otherwise opening "Add New Supplier" after "Replace with Supplier" can show the previous selection.
        window.reactComponents.unmountDynamicComponent(mountAt);
        var isNewSupplier = mode === 'new';
        var nd = $scope.novateData;
        var appName = $rootScope.appName || '';
        var baseUrl = appName + '/options/' + (nd.supplierOptionId || 3) + '?pageType=' + (nd.destinationPageType || 1) + '&entityTpeId=' + (nd.supplierEntityTypeId || 1) + '&novation=true';
        if (nd.sourceRelationid) {
            baseUrl += '&relationId=' + nd.sourceRelationid;
        } else if (nd.sourceRelations && nd.sourceRelations.length) {
            baseUrl += '&relationId=' + nd.sourceRelations[0].id;
        }
        var fieldKey = isNewSupplier ? 'newSupplier' : 'replaceSupplier';
        var fLayout = angular.copy($scope.fieldLayoutData[fieldKey]);
        fLayout.advancedFilterMetaDataUrl = SirionUtils.addQueryString('/v3/listRenderer/advanced-filter/metadata/3', '_t=' + new Date().getTime());
        fLayout.advancedFilterDataUrl = SirionUtils.addQueryString('/v3/listRenderer/advanced-filter/data/3', '_t=' + new Date().getTime());
        fLayout.advancedFilterAutoCompleteUrl = '/v3/listRenderer/list/advanced-filter/option-data/3';
        var autoCompleteDetails = window.getNovationReplaceSupplierAutoCompleteDetails && window.getNovationReplaceSupplierAutoCompleteDetails(fLayout, nd);
        if (!autoCompleteDetails || !autoCompleteDetails.getData) {
            autoCompleteDetails = {
                loaded: 0,
                hasNext: true,
                set: 50,
                getData: buildNovationFallbackGetData(baseUrl)
            };
        }
        var selectedOptions;
        if (isNewSupplier) {
            selectedOptions = ($scope.novatePostData.newRelations && $scope.novatePostData.newRelations.values) ? [].concat($scope.novatePostData.newRelations.values) : [];
        } else {
            var selectedVal = item && item.replacedSuppliers && item.replacedSuppliers.values;
            selectedOptions = (selectedVal && (selectedVal.id || selectedVal.name)) ? selectedVal : null;
        }
        var lang = {
            modalHeaderName: (window.intl_msg[35480]) || 'Available options',
            modalSelect: (window.intl_msg[23637]) || 'Select',
            modalCancel: (window.intl_msg[23731]) || 'Cancel',
            modalClearAll: (window.intl_msg[24195]) || 'Clear All',
            modalRightHeader: (window.intl_msg[37513]) || 'Selection Made',
            modalLeftHeader: (window.intl_msg[35480]) || 'Available options'
        };
        var closeModal = function() {
            if (window.reactComponents && mountAt) {
                window.reactComponents.unmountDynamicComponent(mountAt);
            }
            $scope.$applyAsync();
        };
        var setSelectedOptions = function(selected) {
            if (isNewSupplier) {
                var selectedArr = selected && selected.length ? selected : [];
                if ($scope.novatePostData.newRelations) {
                    $scope.novatePostData.newRelations.values = selectedArr;
                }
                if ($scope.fieldLayoutData && $scope.fieldLayoutData.newSupplier) {
                    $scope.fieldLayoutData.newSupplier.selectedVals = selectedArr;
                }
                closeModal();
                $timeout(function() {
                    var inputEl = angular.element(document.querySelector('#elem_3 input.autoCompleteNov'));
                    if (inputEl.length) {
                        var scope = inputEl.scope();
                        if (scope && scope.appendSelectedElements && $scope.fieldLayoutData && $scope.fieldLayoutData.newSupplier) {
                            scope.appendSelectedElements(inputEl, $scope.fieldLayoutData.newSupplier);
                        }
                    }
                }, 150);
            } else {
                if (item && item.replacedSuppliers) {
                    item.replacedSuppliers.values = selected;
                }
                closeModal();
            }
        };
        var propsToPass = {
            fieldType: null,
            addDocumentTag: null,
            filterOption: function() {},
            CustomLabelComponent: null,
            searchQuery: '',
            debounceDelay: 500,
            isMultiSelect: isNewSupplier,
            hideSelectAll: false,
            alphabeticalSearch: false,
            isAutoComplete: true,
            filterType: null,
            autoCompleteDetails: autoCompleteDetails,
            hasAdditionalOptions: false,
            showAdditionalOptions: false,
            allOptions: [],
            selectedOptions: selectedOptions,
            setSelectedOptions: setSelectedOptions,
            lang: lang,
            groupByParentField: null,
            dataAccessor: 'name',
            LoaderComponentSelect: null,
            NoDataComponentSelect: null,
            setShowListView: closeModal,
            fLayout: fLayout,
            onModalTextChange: function() {},
            uiFilteringRequired: false
        };
        window.reactComponents.mountDynamicComponent('#novationSirionSelectModalMount', 'SirionSelectModal', propsToPass);
    };

    $scope.openReplaceSupplierModal = function(event, item) {
        $scope.openNovationSupplierModal(event, 'replace', item);
    };

    $scope.openNewSupplierModal = function(event) {
        $scope.openNovationSupplierModal(event, 'new');
    };
}]);